import axios from 'axios'
import qs from 'qs'


import {
	MessageBox,
	Message,
	Loading
} from 'element-ui'
import store from '@/store'
// import {
//     getToken,
//     setToken,
//     setRefreshToken,
//     getExpires,
//     setExpires
// } from '@/utils/auth'
import router from '@/router'
// import { login } from '@/api/system/user'

// 创建一个axios实例
// const service = axios.create({
//   baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
//   // withCredentials: true, // send cookies when cross-domain requests
//   timeout: 5000 // request timeout
// })

let instance = axios;
let cacheRequestArr = []; //挂起的请求数组
const Token = localStorage.getItem('keyToken') || '';
// console.log(Token,'Token')
//const Token = "7517da04f3854ef0a5b0f9592e22f582";


//instance.defaults.baseURL = '//127.0.0.1:48080';
//instance.defaults.baseURL = 'http://test.pc.zgjyzjw.com/beishida';
instance.defaults.baseURL = 'https://www.zgjyzjw.com/beishida';

//instance.defaults.baseURL = 'http://beishida-pc.newjunhe.com/beishida';
//instance.defaults.baseURL = 'http://192.168.1.118:48099';
// 本地：http://192.168.1.101:48099
//测试环境  http://beishida-pc.newjunhe.com/beishida/app-api/biz/home/get-expertPage
//开发环境  http://192.168.1.101:48099/app-api/biz/home/index
// instance.defaults.baseURL='/'+process.env.VUE_APP_BASE_API;
window.isRefreshing = false; //是否正在刷新的标志

// 请求拦截器
instance.interceptors.request.use(
	config => {
		config.headers['Authorization'] = Token ? 'Bearer ' + Token : '';
		config.headers['terminal'] = 11;
		if (store.getters.token && store.getters.token) {
			if (config.loading) {
				startLoading();
			} else {}
			// 让每个请求都携带令牌
			config.headers['Authorization'] = Token ? 'Bearer ' + Token : '';
			config.headers['terminal'] = 11;
			//本地环境（不通过网关调用接口时，需要添加）
			// if (process.env.NODE_ENV == 'development') {
			//     config.headers['jwt-subject'] = '1'
			// } else {}
		} else {}
		config.paramsSerializer = function(params) {
			return qs.stringify(params, {
				arrayFormat: 'repeat'
			})
		}
		return config
	},
	error => {
		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

// 响应拦截器
instance.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		const res = response.data;
		// if(res.code == 401){
		// 	Message({
		// 	    message: res.msg || 'Error',
		// 	    type: 'warning',
		// 	    duration: 5 * 1000
		// 	})
		// 	return
		// }
		// if the custom code is not 20000, it is judged as an error.
		if (res.code < 0) {
			if (res.code == -1 || res.code == '-1') {
				Message({
					message: res.msg || 'Error',
					type: 'warning',
					duration: 5 * 1000
				})
			} else {
				Message({
					message: res.msg || 'Error',
					type: 'error',
					duration: 5 * 1000
				})
			}
			return Promise.reject(new Error(res.msg || 'Error'))
		} else {
			return res
		}
	},
	error => {
		console.log('拦截器报错:' + JSON.stringify(error));
		const response = error.response;
		let shouldLogout = false;

		if (error && response) {
			switch (error.response.status) {
				case 400:
					error.message = '请求错误(400)';
					break;
				case 401:
					//令牌过期无效
					error.message = "登录信息过期,请重新登录";
					// error.message=response.data.message;
					shouldLogout = true;
					console.log("令牌无效(401)", response);
					break;
				case 403:
					error.message = '拒绝访问(403)';
					break;
				default:
					error.message = `连接出错(${error.response.status})!`;
			}

		} else {
			error.message = '连接服务器失败!'
		}

		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})

		// if(shouldLogout){
		//   //清理缓存跳转登录页
		//   store.dispatch("user/logout").then(() => {
		//     router.push({path:'/login'});
		//   })
		//   .catch((error) => {
		//     console.log("令牌无效(401)",error);
		//   });
		// }
		return Promise.reject(error)
	}
)

export default instance
